import * as React from "react";
import { SVGProps } from "react";
const SvgGas = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.97 3.118c6.346 3.374 11.53 9.964 11.53 15.883 0 5.734-3.352 10-10 10-5.382 0-9-3.289-9-8 0-2.693.742-4.442 2.618-7.078l.617-.852c2.399-3.295 3.158-5.27 2.77-8.966a1 1 0 0 1 1.464-.987h.001Zm.633 2.69c.001 3.044-.936 5.194-2.998 8.089l-.629.867C9.15 17.279 8.5 18.716 8.5 21c0 2.484 1.305 4.422 3.56 5.367-.434-.604-.664-1.343-.664-2.16 0-3.79 3.894-4.355 5.104-9.207 2.558 2.07 4 5 4 8 0 .977-.234 2.193-.915 3.18C22.226 24.926 23.5 22.32 23.5 19c0-4.595-3.88-9.953-8.897-13.193v.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGas;
